const formatterWithDecimals = new Intl.NumberFormat("fr-FR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});
const formatterWithoutDecimals = new Intl.NumberFormat("fr-FR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
});

export default {
    methods: {
        shortenText(str) {
            return str === str.substring(0,20) ? str : str.substring(0, 20) + "...";
        },
        formatNumber(x) {
            let value = Number(('' + x).replace(',', '.'));
            if (isNaN(value)) {
                return x;
            } else {
                if (Number.isInteger(value)) {
                    return formatterWithoutDecimals.format(value);
                }
                return formatterWithDecimals.format(value);
            }
        },
        formatNumberWithDecimals(x) {
            let value = Number(('' + x).replace(',', '.'));
            if (Number.isNaN(value)) {
                return x;
            } else {
                return formatterWithDecimals.format(value);
            }
        },
        deformatNumber(x) {
            return Number(('' + x).replace(',', '.'));
        },
        formatSecondsAsDays(seconds) {
            // Return seconds equivalent of full days (devide seconds by the number of seconds in a day)
            return Math.floor(seconds / 86400) || 0;
        },
        formatSecondsAsDayHours(seconds) {
            // Return remaining hours
            return Math.round((seconds % 86400) / 3600) || 0;
        },
    }
}
